






















import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import UserInquiryCategory from '@/ts/UserInquiryCategory';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component
export default class CategoriesView extends Mixins(LocalizationMethods) {
    constructor() {
        super();
    }

    get activeType() {
        return this.$store.getters['HomeAssistant/getActiveType'];
    }

    get categories(): UserInquiryCategory[] {
        return this.$store.getters['UserTicketsAttributes/getTypeInquiryCategories'](this.activeType.id);
    }

    public changeView(category: UserInquiryCategory) {
        this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_CATEGORY, category);
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_CURRENT_VIEW, 'QuestionsView');
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_PREV_VIEW, 'CategoriesView');
    }

    public created() {
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_PREV_VIEW, 'TypesView');
    }
}
